'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { Button } from '@/components/ui/button';
import './globals.css';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="fr">
      <body className="antialiased min-h-screen flex flex-col items-center justify-center gap-6 p-6 text-center">
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold">Une erreur est survenue</h1>
          <p className="text-muted-foreground">
            L&apos;équipe PLUO a été notifiée. Vous pouvez réessayer.
          </p>
          {error.digest && (
            <p className="text-xs text-muted-foreground">Référence : {error.digest}</p>
          )}
        </div>
        <Button onClick={() => reset()}>Réessayer</Button>
      </body>
    </html>
  );
}
